import React, { useEffect, useRef, useState } from "react"
import { Container, Spinner } from "reactstrap"
import "@formatjs/intl-numberformat/polyfill"
import toastr from "toastr"
import FiltersMonitor from "./filters-component"
import Breadcrumb from "components/Common/Breadcrumb"

function Monitoramento() {
  //meta title
  document.title = "Monitoramento"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Processamento" breadcrumbItem="Monitoramento" />

          <FiltersMonitor />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Monitoramento
